module.exports = __webpack_public_path__ + "img/icon-remove white.24c2c8a5.svg";